export default {
  companyName: "(주)한국문화체육진흥원",
  companyEnName: "Korea Culture & Sports Promotion Institute Co., Ltd",
};